<script>
  import { onMount } from "svelte";
  export let targetId = null;
  export let targetClass = null;
  export let className = null;

  let ref;
  let portal;

  onMount(() => {
    portal = document.createElement("div");
    portal.className = className;
    if (targetId) document.getElementById(targetId).appendChild(portal);
    else if (targetClass) {
      document.querySelectorAll(`.${targetClass}`).forEach((el) => {
        el.appendChild(portal);
      });
    } else document.body.appendChild(portal);
    portal.appendChild(ref);
  });
</script>

<div bind:this={ref}>
  <slot />
</div>

<style>
</style>
